$(document).ready(function () {

  // Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    window.location.href = url;
  });

  // Gestion des sous-menus

  // Fonction pour réinitialiser le menu
  function resetMenu() {
    $('.with_submenu').removeClass('actif');
    $('.menu-drawer-bg').css('background-image', 'url()');
    $('.menu-drawer-submenu nav').hide();
    $('.menu-drawer-submenu').removeClass('menu-opening');
  }

  // Fonction pour afficher le sous-menu
  function showSubmenu(target) {
    $('.menu-drawer-submenu nav[data-submenu="' + target + '"]').show();
  }

  // Fonction pour définir le comportement en fonction de la largeur de l'écran
  function submenuBehavior(isHover) {
    return function () {
      resetMenu();
      $(this).addClass('actif');
      const subtarget = $(this).data('subtarget');
      showSubmenu(subtarget);

      if (!isHover) {
        $('.menu-drawer-submenu').addClass('menu-opening');
        const decalage = $('.menu-drawer').scrollTop();
        if (decalage > 0) {
          $('.menu-drawer-submenu').css('top', decalage);
        }
        $('.menu-drawer').css('overflow-y', 'hidden');
      }
    };
  }

  // Détection de la largeur de la fenêtre
  if ($(window).width() > 749) {
    $('.with_submenu').hover(submenuBehavior(true));
  } else {
    $('.with_submenu').click(submenuBehavior(false));
  }

  // Lors d'un click sur .submenu_back, visible sur mobile
  $('.submenu_back').click(function () {
    resetMenu();
    $('.menu-drawer').css('overflow-y', 'auto');
  });

  // Lors d'un hover sur .menu-drawer-espaces ou .menu-drawer-contextuel
  $('.menu-drawer-espaces, .menu-drawer-contextuel').hover(function () {
    resetMenu();
  });

  // Affichage de la photo de collection sur le header
  $('.menu-drawer-submenu a').hover(function () {
    var image = $(this).data('bg');
    $('.menu-drawer-bg').css('background-image', 'url(' + image + ')');
  });

  // Onclick sur .menu-drawer-bg
  $('.menu-drawer-bg').click(function () {
    resetMenu();
    $('.menu-drawer').css('overflow-y', 'auto');

    const headerDrawerElement = document.querySelector('header-drawer');
    if (headerDrawerElement) {
      headerDrawerElement.closeMenuDrawer(null, document.querySelector('.header__icon--summary'));
    }
  });


  // Card-product : affichage de l'image au survol des couleurs alternatives
  $(".color_alternatives span:not(.current_color)").hover(
    function () {
      // Création de l'image et ajout au DOM
      var image = $(this).data("alt_product_img");
      var imgElement = $('<img>', {
        'src': image,
        'class': 'alternative-img', // Ajout d'une classe pour faciliter la suppression
        'loading': 'lazy'
      });

      // Trouver le conteneur .media et insérer l'image comme deuxième enfant
      var mediaContainer = $(this).closest('.card').find('.card__media .media');
      if (mediaContainer.children().length >= 1) {
        mediaContainer.children().eq(0).after(imgElement);
      } else {
        mediaContainer.prepend(imgElement);
      }
    },
    function () {
      // Suppression de l'image ajoutée précédemment
      $(this).closest('.card').find('.card__media .media .alternative-img').fadeOut(100, function () {
        $(this).remove();
      });
    }
  );

  // Card-product : au click sur une couleur alternative
  $(".color_alternatives span").click(function () {
    var url = $(this).data("alt_product_target");
    window.location.href = url;
  });

  // Sélection du mode d'affichage des grids
  $(".facets_grid_selector button").click(function () {
    var grid = $("#product-grid");

    grid.removeClass("grid--8-col-desktop grid--4-col-desktop grid--2-col-desktop grid--1-col-desktop grid--2-col-tablet-down grid--1-col-tablet-down");
    grid.addClass($(this).data("grid_class"));

    $(".facets_grid_selector button").removeClass("active");
    $(this).addClass("active");

    // Stocker le choix dans localStorage
    localStorage.setItem("selectedGridClass", $(this).data("grid_class"));

    // Mise à jour des espacements horizontaux en fonction du nombre de colonnes
    var spacing;
    switch ($(this).data("grid_class")) {
      case "grid--8-col-desktop":
        spacing = '62px';
        break;
      case "grid--2-col-desktop":
        spacing = '132px';
        break;
      default:
        spacing = '16px';
        break;
    }
    document.documentElement.style.setProperty('--grid-desktop-horizontal-spacing', spacing);
  });

  // Lors d'un click sur la réinitilisation de la recherche, on supprime le contenu html du #predictive-search-results
  $('.reset__button').click(function () {
    $('#predictive-search-results').html('');
  });

  // Footer sur mobile
  $('.nav_block nav > p').on('click', function () {
    if ($(window).width() < 768) {
      var $div = $(this).siblings('div');

      if ($div.css('display') === 'none') {
        $div.css('display', 'flex');
      } else {
        $div.css('display', 'none');
      }
      $(this).find('svg').toggleClass('rotate');
    }
  });


  /* DRAWERS */

  // on click on .drawer_close close the closest .drawer
  $(".drawer_close").click(function () {
    $(this).closest(".drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  // on click on .drawer_wrapper_overlay, close the closest .drawer
  $(".drawer_wrapper_overlay").click(function () {
    $(this).closest(".drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  // Affichage du drawer disponibilité en boutiques
  $(".product_disponibilite_boutique_cta").click(function () {
    $("#drawer_disponibilite").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  // replier par défaut les détails de la disponibilité boutiques
  $('.boutique_details').hide();

  // replier par défaut les caractéristiques produit
  $('.product_info_content').hide();

  // ouvrir le détail boutique on clic
  $('.toggle_details').on('click', function () {
    $(this).toggleClass('actif');
    $(this).siblings('.boutique_details').slideToggle(200);
  });

  // Affichage du drawer caractéristiques produit
  $(".product_caracteristiques").click(function () {
    $("#drawer_caracteristiques").addClass("active");
    $("body").addClass("overflow-hidden");
  });


  /* $('.toggle_carac').on('click', function () {
    $(this).toggleClass('actif');
    $(this).closest('.product_info_bloc').find('.product_info_content').slideToggle(200);
  }); */

  // Ouvrir le détail caractéristiques produit on clic
  $('.product_composition, .product_entretien').on('click', function () {
    $(this).find('.toggle_carac').toggleClass('actif');
    $(this).closest('.product_info_bloc').find('.product_info_content').slideToggle(200);
  });

  // Affichage du drawer sizeguide
  $(".product__sizeguide_cta").click(function () {
    $("#drawer_sizeguide").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  // Affichage du drawer sizeguide
  $(".product-devis__submit").click(function () {
    $("#drawer_surdevis").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  // Gestion de la FAQ
  if ($('.faq_page_main').length) {
    createFaq();
  }

  // si on trouve des .color_alternatives span, on vérifie la luminosité de la couleur et on passe le span en question en argument
  if ($('.color_alternatives span').length) {
    $('.color_alternatives span').each(function () {
      checkColor(this, $(this).css('background-color'));
    });
  }

});


/* Gestion de la FAQ */
function createFaq() {
  $('.faq_page_main h2').each(function (index) {
    $(this).addClass('question'); // Ajoute la classe 'question' aux <h2>
    var answerDiv = $('<div class="answer"></div>'); // Crée un div de classe 'answer' pour entourer le contenu
    $(this).after(answerDiv); // Insère le div 'answer' après le <h2>

    // Déplace les éléments suivants dans le div 'answer' jusqu'au prochain <h2> ou à la fin du contenu
    var nextSiblings = $(this).nextUntil('h2');
    nextSiblings.appendTo(answerDiv);
    answerDiv.hide(); // Masque le contenu 'answer' par défaut

    // Si c'est le premier <h2>, afficher le contenu par défaut
    if (index === 0) {
      answerDiv.show();
      $(this).addClass('open'); // Ajoute la classe 'open' pour indiquer que le premier est ouvert
    } else {
      answerDiv.hide(); // Masque le contenu 'answer' par défaut
    }

    $(this).click(function () {
      var isOpen = answerDiv.is(':visible');
      answerDiv.stop(true, true).slideToggle(200, 'swing');

      // Mise à jour de l'icône
      $(this).toggleClass('open', !isOpen);
    });
  });
}

// Fonction pour calculer la luminosité perçue
function getLuminance(r, g, b) {
  // Convertir les valeurs RGB en luminance perçue
  const a = [r, g, b].map(function (v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  // Formule de luminosité relative
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

// Fonction pour vérifier si la couleur est trop claire
function isColorTooLight(hexColor) {
  const rgb = hexColor.match(/\d+/g).map(Number);
  const luminance = getLuminance(rgb[0], rgb[1], rgb[2]);
  return luminance > 0.8;
}

// Fonction principale pour appliquer la classe si nécessaire
function checkColor(dot, hexColor) {
  if (isColorTooLight(hexColor)) {
    dot.classList.add('bordered');
  }
}